import BaseServices from '@/store/services/index'
const baseService = new BaseServices()

export default {
  state: {
    getComplementaryProducts: []
  },

  getters: {
    getComplementaryProducts: state => state.getComplementaryProducts
  },

  mutations: {
    setComplementaryProducts(state, val) {
      state.getComplementaryProducts = val
    }
  }
}